import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Leaf, Headphones, MessageSquareHeart, CalendarHeart, UserRound, LogOut, ShieldCheck } from "lucide-react";
import { Button } from "@/components/ui/button";

const links = [
  { to: "/spazio", label: "Threshold", icon: Leaf },
  { to: "/ascolti", label: "Listen", icon: Headphones },
  { to: "/testimonianze", label: "Testimonies", icon: MessageSquareHeart },
  { to: "/incontri", label: "Meetings", icon: CalendarHeart },
  { to: "/profilo", label: "My space", icon: UserRound },
];

export default function MemberLayout() {
  const { user, logout, isAdmin } = useAuth();
  const navigate = useNavigate();

  const doLogout = async () => {
    await logout();
    navigate("/");
  };

  return (
    <div className="min-h-screen bg-background">
      <header className="sticky top-0 z-40 bg-background/90 backdrop-blur-md border-b border-border">
        <div className="max-w-6xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between gap-4">
          <NavLink to="/spazio" className="font-heading text-lg sm:text-xl uppercase tracking-[0.18em] text-foreground" data-testid="brand-link">
            Self Doubling<span className="text-primary">©</span>
          </NavLink>
          <nav className="hidden md:flex items-center gap-1">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                data-testid={`nav-${l.label.toLowerCase().replace(/\s/g, "-")}`}
                className={({ isActive }) =>
                  `px-4 py-2 rounded-full text-xs uppercase tracking-[0.14em] transition-colors duration-200 ${
                    isActive ? "bg-secondary text-primary" : "text-muted-foreground hover:text-foreground"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
          </nav>
          <div className="flex items-center gap-2">
            {isAdmin && (
              <Button variant="ghost" size="sm" className="rounded-full text-muted-foreground uppercase tracking-[0.12em] text-xs" onClick={() => navigate("/admin")} data-testid="go-admin-btn">
                <ShieldCheck className="w-4 h-4 mr-1" /> Back office
              </Button>
            )}
            <button onClick={doLogout} data-testid="logout-btn" className="p-2 rounded-full hover:bg-secondary transition-colors" title="Sign out">
              <LogOut className="w-5 h-5 text-muted-foreground" />
            </button>
          </div>
        </div>
        <nav className="md:hidden flex items-center gap-1 px-3 pb-2 overflow-x-auto">
          {links.map((l) => (
            <NavLink key={l.to} to={l.to} className={({ isActive }) =>
              `flex items-center gap-1 px-3 py-1.5 rounded-full text-xs whitespace-nowrap ${isActive ? "bg-secondary text-primary" : "text-muted-foreground"}`}>
              <l.icon className="w-3.5 h-3.5" /> {l.label}
            </NavLink>
          ))}
        </nav>
      </header>
      <main className="max-w-6xl mx-auto px-5 sm:px-8 py-10 sm:py-14 animate-fade-in-up" key={user?.id}>
        <Outlet />
      </main>
      <footer className="border-t border-border py-8 text-center text-xs text-muted-foreground">
        © {new Date().getFullYear()} Self Doubling© – Mosca Method. All rights reserved. Content is copyright protected.
      </footer>
    </div>
  );
}
